
import { useState, useEffect } from "react";
import { href, useNavigate } from "react-router-dom";
import { ConsultarIPedidosEncomendaFornecedor, SeparaPedidoClienteFornecedor } from "../funcionalidades/bancoGet";
import GlobalVar from "./GlobalVar";
import Swal from 'sweetalert2'

function adicionaQuebraLinhaData(data) {

    let partes = data.split(' ');
  let resultado = [];
  for(let i = 0; i < partes.length; i++) {
    resultado.push(partes[i]);
    if(i < partes.length - 1) {
      resultado.push(<br />);
    }
  }
  return resultado;
}

const ComponenteNotaFornecedor = ({item, ativaResp, setShowAlert, usuarioTipo, romaneioGerado})=>{

    const [showItens, setShowItens] = useState(false)
    const [itensNota, setItensNota] = useState('Carregando ...')

    let data = GlobalVar.formatarData(new Date((item.data)))
    let dataCab = `${data[0]}/${data[1]}/${data[2]}`
    let dataItem = `${data[2]}-${data[1]}-${data[0]}`
    // const item = {...JSON.parse(JSON.stringify(item)), tipo: item.tipo
    //     destino}

    const navigate = useNavigate();

    useEffect(()=>{
        if(showItens){
                ConsultarIPedidosEncomendaFornecedor({documento: item.documento})
                .then((resp)=>{
                    if(resp.Error){
                        setShowAlert(resp.Error);
                    }else{
                        const respostaTratada = resp.reduce((acc, curr) => {
                            if(!acc[curr.rev_nom]) {
                                acc[curr.rev_nom] = [];
                            }
                            acc[curr.rev_nom].push(curr);
                            return acc;
                        }, {});
                        setItensNota(respostaTratada)
                    }
                    
                })
            
        }
    },[showItens])


    function separarPedidoCliente(documento){
        return new Promise ((resolve) =>{
            SeparaPedidoClienteFornecedor({DOCUMENTO: item.documento})
            .then((resp)=>{
                if(resp.Error || resp["ERROR SERVER"]){
                    resolve(false)
                }else{
                    resolve(resp.rom_cod)
                }
                
            })
        })
    }
    

    return <div className="itemNota fornecedor">
       <div className={`cabecalhoNota `} onClick={()=>setShowItens(!showItens)}>
            {/* <div>{index}</div> */}
            {ativaResp ? <>
                <div>LOJ.:&nbsp;{item.loja}</div>
                <div>Doc.:&nbsp;{item.documento}</div>
                <div>{item.doctoclie}</div>
                <div>{item.nomeclie.split(" ").slice(0,3).join(" ").slice(0,20)}</div>
                <div>Qtde. Total:{" "+item.totalitens}</div>

            <div>Total: {GlobalVar.converteReais(item.totalgeral)}</div>
            <div>{dataCab}</div>
            </> : 
            <>  
                <div>{item.documento}</div>

                <div>{item.doctoclie}</div>
                <div>{item.nomeclie.split(" ").slice(0,3).join(" ").slice(0,20)}</div>
                <div>Loja: {item.loja}</div>


                <div>{item.totalitens}</div>

                <div>{GlobalVar.converteReais(item.totalgeral)}</div>
                <div>{dataCab}</div>
                </>}
        </div>

 

        {showItens ?<div className="itensNota">


             <div className='lineBar'></div>
             

                        <div
                        className="buttonEntregaPedidoFornecedor"
                        onClick={async () => {

                            const result = await Swal.fire({
                            title: 'Confirmar ação?',
                            text: romaneioGerado
                                ? 'Deseja visualizar o romaneio?'
                                : 'Deseja separar o pedido e gerar o romaneio?',
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonText: 'Sim, continuar',
                            cancelButtonText: 'Cancelar'
                            });

                            if (!result.isConfirmed) return;

                            try {
                            if (!romaneioGerado) {
                                const resultado = await separarPedidoCliente(item.documento);

                                if (resultado) {
                                await Swal.fire({
                                    title: 'Sucesso!',
                                    text: 'Pedido separado com sucesso.',
                                    icon: 'success'
                                });

                                navigate(`/PedidoRelatorioRomaneio?doc=${resultado}`);
                                }
                            } else {
                                const doc = item.rom_doc
                                .split('ROMANEIO GERADO ')[1]
                                .replace(/\D/g, '');

                                navigate(`/PedidoRelatorioRomaneio?doc=${doc}`);
                            }
                            } catch (err) {
                            Swal.fire({
                                title: 'Erro!',
                                text: 'Ocorreu um problema ao processar a ação.',
                                icon: 'error'
                            });
                            }
                        }}
                        >
                        {romaneioGerado ? 'Visualizar Romaneio' : 'Separar Pedido'}
                        </div>

            {itensNota !== 'Carregando ...' ? Object.keys(itensNota).map((revistaColecaoItens,i)=>{
                    const itensArr = itensNota[revistaColecaoItens]
                    
                    return <>


                    <div className="titleRevMov fornecedor" key={`title${item.documento}`}>{revistaColecaoItens}</div>
                        <div className="itemsMov fornecedor" key={`itens${item.documento}`}>

                            {itensArr.map((subItem,i)=>{
                               return <> 
                                <div className="subItemMov fornecedor" key={`subItens${item.documento}`}>
                                    <div>{subItem.fabricante.substr(0,24)}</div>
                                    <div>{subItem.item.substr(0,38)}</div>
                                    <div>COR: {subItem.procor_descricao_cor.substr(0,12)}</div>
                                    {ativaResp ? <div className="flexTam">
                                        <div>TAM.: {subItem.tam_nom}</div>
                                        <div className='qtde'>{`${subItem.qtde}`} UN</div>
                                    </div> : <>
                                    <div>TAM.: {subItem.tam_nom}</div>
                                        <div className='qtde'>{`${subItem.qtde}`} UN</div>
                                    </>}
                                </div>
                                <div className='lineBar'></div>
                            </>
                            })}
                            <div className="totalItemMov">
                                <div></div>
                                <div>Items: {`${itensArr.reduce((acc, curr) => {
                                            return acc + parseInt(curr.qtde);
                                        }, 0)}`}</div>
                            </div>
                            
                        </div>
                        </>
                    }) : 'Carregando ...'}  
        </div> : <></>}
    </div>
}

export default ComponenteNotaFornecedor;